<template lang='slm'>
.bz-article.row
  .col-12 v-if='bzData.title'
    h3 {{ localized('title') }}
  component :is="tagByModel(child[0])" v-for="child in children" :id="child[1]" :key="compoundKey(...child)"
</template>
<script>
import BzTreeItem from '@/components/mixins/bz-tree-item'
import BzParagraph from '@/components/bz-tree/BzParagraph'
import BzText from '@/components/bz-tree/BzText'
import FontAwesomeIcon from '@/fontawesome'

export default {
  mixins: [ BzTreeItem ],
  components: { BzParagraph, BzText, FontAwesomeIcon },
  methods: {
    openEditor () {
      this.$store.dispatch('editor/setEditing', this.dataKey)
    }
  }
}
</script>
<style scoped lang='scss'>
  @import 'node_modules/bootstrap/scss/bootstrap-reboot';

  $spasing: ($grid-gutter-width / 2);

  .controls {
    min-height: 0;
  }

  .edit {
    position: absolute;
    right: $spasing;
    top: -$spasing;
    z-index: 10;
  }
</style>



// WEBPACK FOOTER //
// src/components/bz-tree/BzArticle.vue